import { useMyOrganizations } from "@/api/organizations/useMyOrganizations";
import { routes } from "@/constants/routes";
import { useNetworkStatus } from "@/network/NetworkContext";
import { useTheme } from "@/theme/ThemeProvider";
import { useStyles } from "@/theme/styles";
import { ClubComposer } from "@/ui/components/club/ClubComposer";
import { Screen } from "@/ui/components/Screen";
import { ErrorState } from "@/ui/components/StateViews";
import { useLocalSearchParams, useRouter } from "expo-router";
import React from "react";
import { Text, View } from "react-native";

export default function ClubNewScreen() {
  const { theme } = useTheme();
  const s = useStyles();
  const router = useRouter();
  const params = useLocalSearchParams<{ kind?: string }>();
  const { isOnline } = useNetworkStatus();
  const { organizations, memberships } = useMyOrganizations();
  const org = organizations[0];
  const roles =
    memberships.find((m) => m.organization_id === org?.id)?.roles ?? [];
  const canCreateEvent = roles.some((r) =>
    ["organizer", "board", "admin"].includes(r)
  );
  const canMarkOfficial = roles.some((r) =>
    ["board", "admin"].includes(r)
  );
  const defaultKind =
    params.kind === "event" || params.kind === "poll" || params.kind === "post"
      ? params.kind
      : "post";

  if (!isOnline) {
    return (
      <Screen title="Neuer Beitrag">
        <Text style={s.textBody}>
          Der Vereinsbereich benötigt eine Internetverbindung.
        </Text>
      </Screen>
    );
  }

  if (!org) {
    return (
      <Screen title="Neuer Beitrag">
        <ErrorState message="Keine aktive Vereinsmitgliedschaft." />
      </Screen>
    );
  }

  return (
    <Screen title="Neuer Beitrag" scroll contentStyle={{ gap: theme.space.lg }}>
      <View>
        <ClubComposer
          organizationId={org.id}
          canCreateEvent={canCreateEvent}
          canMarkOfficial={canMarkOfficial}
          defaultKind={defaultKind}
          onCreated={(itemId) => {
            if (itemId && defaultKind === "event") {
              router.replace(routes.myCalendarItem(itemId) as never);
            } else if (itemId) {
              router.replace(routes.myClubItem(itemId) as never);
            } else {
              router.replace(routes.myClub as never);
            }
          }}
        />
      </View>
    </Screen>
  );
}
